<!-- Tasklists Header -->
<mat-toolbar color="accent">
  <span role="heading" class="mat-title">Lists</span>
  <span class="spacer"></span>
  <!-- Tasklists List Actions -->
  <span role="toolbar">
    <button id="tasklists-add" mat-raised-button (click)="add()">
      <mat-icon>add_task</mat-icon> New List
    </button>
  </span>
</mat-toolbar>
<!-- Tasklists List-->
<mat-list id="tasklists-list">
  <mat-list-item *ngFor="let taskList of taskListArray$|async; index as i" [tabindex]="i" (click)="onSelect(taskList)">
    <div matLine>{{ taskList.title }}</div>
    <span class="spacer"></span>
    <button mat-icon-button class="icon-btn-sm" aria-label="Rename" (click)="rename(taskList)"><mat-icon>create</mat-icon></button>
    <button mat-icon-button class="icon-btn-sm" aria-label="Delete" (click)="delete(taskList)"><mat-icon>delete</mat-icon></button>
  </mat-list-item>
</mat-list>
